import Axios from '@/tool/axios.js';

export default class Admin {
  constructor(admin) {
    admin = admin || {};
    this.id = admin.id || -1;
    this.username = admin.username || '';
    this.password = admin.password || '';
    }

    inviteLogin(data) {
        const that = this;
        return Axios({
            url: `/api/wx/employee/login`,
            method: 'put',
            isFormData: true,
            data: data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }

  login() {
    const that = this;
    return Axios({
      // url: `/api/wx/employee/login`,
    //   url: '/api/admin/user/login',
      url: '/aichat/api/admin/digitalHuman/user/login',
      method: 'put',
      isFormData: true,
      data: {
        username: that.username,
        password: that.password
      }
    }).then(
      res => Promise.resolve(res),
      err => Promise.reject(err)
    );
  }

  logout() {
    return Axios({
      // url: `/api/wx/employee/logOut`,
    //   url: `/api/admin/user/logout`,
      url: `/aichat/api/admin/digitalHuman/user/logout`,
      method: 'put'
    }).then(
      res => Promise.resolve(res),
      err => Promise.reject(err)
    );
  }

  getCurrentInfo() {
    return Axios({
      // url: `/api/wx/employee/currentEmployee`,
    //   url: `/api/admin/user/current`,
      url: `/aichat/api/admin/digitalHuman/user/current`,
      method: 'get'
    }).then(
      res => Promise.resolve(res),
      err => Promise.reject(err)
    );
  }

  getSessionByOauth(requestId) {
    const that = this;
    return Axios({
      url: `/api/wx/employee/getSessionByOauth`,
      method: 'put',
      isFormData: true,
      data: {
        requestId
      }
    }).then(
        res => Promise.resolve(res),
        err => Promise.reject(err)
    );
  }

  authLogin(code) {
    const that = this;
    return Axios({
      // url: `/api/admin/user/authLogin`,
      url: `/api/admin/user/authLogin`,
      method: 'put',
      isFormData: true,
      data: {
        code
      }
    }).then(
        res => Promise.resolve(res),
        err => Promise.reject(err)
    );
  }

  getOauthLoginUrl(data) {
    return Axios({
      url: `/api/admin/wxUser/getOauthLoginUrl`,
      method: 'get',
      params: data
    }).then(
        res => Promise.resolve(res),
        err => Promise.reject(err)
    );
  }

  loginBySupportSid(data) {
    return Axios({
      url: `/aichat/api/admin/digitalHuman/user/loginBySupportSid`,
      method: 'get',
      params: data
    }).then(
      res => Promise.resolve(res),
      err => Promise.reject(err)
    );
  }

}




// WEBPACK FOOTER //
// ./src/digitalHuman/tool/Admin.js